import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle } from 'lucide-react';
import { PaymentTrust } from './PaymentTrust';
export function ValueStack() {
  const items = [{
    name: 'Main Book: The Master Code',
    description: '',
    price: '$29.00'
  }, {
    name: 'BONUS 1: SUPPLEMENT GUIDE',
    description: 'What to take for a firm and long-lasting erection.',
    price: '$10.00'
  }, {
    name: 'BONUS 2: REGAIN YOUR FIRMNESS',
    description: 'How to raise testosterone naturally and safely.',
    price: '$15.00'
  }, {
    name: 'BONUS 3: THE HARDNESS DIET',
    description: 'Foods that work as a natural booster.',
    price: '$9.00'
  }, {
    name: 'BONUS 4: MASTER CHECKUP',
    description: 'Understand your blood work without complications.',
    price: '$9.00'
  }, {
    name: 'BONUS 5: POWER DISCHARGE',
    description: 'Guide to improved volume, taste, and density.',
    price: '$7.80'
  }];
  return <section id="pricing" className="py-24 px-6 bg-dark-card relative" data-id="element-242">
      <div className="max-w-4xl mx-auto" data-id="element-243">
        <FadeIn data-id="element-244">
          <div className="text-center mb-16" data-id="element-245">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white leading-tight" data-id="element-246">
              Today you are not just buying a book. <br data-id="element-247" />
              <span className="text-gold italic" data-id="element-248">
                You are acquiring the complete system.
              </span>
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-249">
          <div className="bg-dark border-2 border-gold/30 rounded-sm p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-250">
            <div className="space-y-4 mb-10" data-id="element-251">
              {items.map((item, index) => <div key={index} className="flex items-start justify-between gap-4 border-b border-gold/10 pb-4" data-id="element-252">
                  <div className="flex items-start gap-3 flex-1 min-w-0" data-id="element-253">
                    <CheckCircle className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-254" />
                    <div className="flex-1 min-w-0" data-id="element-255">
                      <p className={index === 0 ? 'text-white font-bold text-lg' : 'text-white font-bold'} data-id="element-256">
                        {item.name}
                      </p>
                      {item.description && <p className="text-gray-400 text-sm mt-1 leading-snug" data-id="element-257">
                          {item.description}
                        </p>}
                    </div>
                  </div>
                  <span className="text-gray-500 line-through decoration-red-500/50 decoration-2 font-mono whitespace-nowrap mt-0.5" data-id="element-258">
                    {item.price}
                  </span>
                </div>)}
            </div>

            <div className="text-center border-t border-gold/30 pt-10" data-id="element-259">
              <p className="text-xl text-gray-400 mb-2" data-id="element-260">
                Total Real Value:{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-261">
                  $79.80
                </span>
              </p>
              <h3 className="text-4xl md:text-5xl font-serif font-bold text-gold drop-shadow-md" data-id="element-262">
                TAKE IT ALL FOR ONLY: $19.99
              </h3>

              {/* Elegant gold hairline divider for breathing room */}
              <div className="flex items-center justify-center gap-3 my-12" data-id="element-263">
                <div className="h-px w-16 bg-gradient-to-r from-transparent to-gold/40" data-id="element-264"></div>
                <div className="w-1.5 h-1.5 rotate-45 bg-gold/60" data-id="element-265"></div>
                <div className="h-px w-16 bg-gradient-to-l from-transparent to-gold/40" data-id="element-266"></div>
              </div>

              <a href="https://templeofpages.com/cart/49096223424755:1" className="inline-block text-center bg-gold hover:bg-gold-light text-dark font-bold py-6 px-8 rounded-sm text-base md:text-xl transition-all duration-300 transform hover:scale-105 shadow-[0_0_30px_rgba(212,175,55,0.3)] uppercase tracking-wide w-full" data-id="element-267">
                YES, I WANT TO REGAIN MY POWER NOW —{' '}
                <span className="text-dark font-extrabold underline decoration-2 underline-offset-4" data-id="element-268">
                  ONLY $19.99
                </span>
              </a>
              <div className="mt-6" data-id="element-269">
                <PaymentTrust compact data-id="element-270" />
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}